import mithril from "mithril"
import Navbar from "../../../component/navbar"
import LeftMenu from "../../../component/leftmenu"
import Footer from "../../../component/footer"
import Joi from "@hapi/joi"

import product_attributes_model from "../../../models/product_attributes"

let inserted_attribute_data = {
    name:null,
    status:null
};
let data = [];

module.exports = {
    oninit:()=>{

        window.scrollTo(0,0);
    },
    view:()=>{
        return mithril("div", [
            mithril("section", {class:"section"}, [
                mithril(Navbar)
            ]),
            mithril("section", {class:"section", style:"margin-top: -120px; "}, [
                mithril("div", {class:"columns"}, [
                    mithril("div", {class:"column is-one-fifth"}, [
                        mithril(LeftMenu, {title: "add_product_attributes"})
                    ]),
                    mithril("div", {class:"column"}, [
                        mithril("h1", {class:"title"}, "Add Product Attribute"),
                        mithril("button", {"class":"button is-info is-outlined is-pulled-right", onclick: function(){
                            mithril.route.set('/products/attributes');
                        }},[
                            mithril("span", {"class":"icon is-small"}, 
                                mithril("i", {"class":"fas fa-angle-left"})
                            ),
                            mithril("span", "Back to List")
                        ]),
                        mithril("div",{class:"is-clearfix"}),
                        mithril("form",[
                            mithril("div", {class: "field"}, [
                                mithril("label", {class:"label"}, "Name"),
                                mithril("div", {class:"control"}, [
                                    mithril("input", {
                                        class:"input", 
                                        type:"text", 
                                        placeholder:"Name",
                                        oninput: function(e){
                                            inserted_attribute_data.name = e.target.value;
                                        }, 
                                        value: inserted_attribute_data.name
                                    })
                                ])
                            ]),
                            mithril("div", {class: "field"}, [
                                mithril("label", {class:"label"}, "Status"),
                                mithril("div", {class:"control"}, [
                                    mithril('div', {class:'select'}, [
                                        mithril('select', {onchange: function(e){
                                        
                                            inserted_attribute_data.status = e.target.value;
                                        }}, [
                                            mithril('option', {selected: 'true', disabled: 'disabled'}, '- Choose Status -'),
                                            mithril('option', {value: 'active',selected: (inserted_attribute_data.status == 'active') ? 'true' : ''}, 'Active'),
                                            mithril('option', {value: 'inactive',selected: (inserted_attribute_data.status == 'inactive') ? 'true' : ''}, 'Inactive'),
                                        ])
                                    ]),
                                ])
                            ]),
                            mithril("div", {class:"field"}, [
                                mithril("div", {class:"control"}, [
                                    mithril("button", {type:"button",class:"button is-link is-primary is-pulled-right",
                                        onclick:function(){

                                            const rule = {
                                                name: Joi.string().required(),
                                                status: Joi.string().valid('active','inactive')
                                            };
                                            
                                            const validation = Joi.object(rule).validate(inserted_attribute_data);
                                            
                                            if (validation.error === undefined) {

                                                product_attributes_model.addAttribute(inserted_attribute_data).then(()=>{

                                                    alert('Attribute Created Successfully');
                                                    mithril.route.set("/products/attributes");
                                                }).catch((err)=>{

                                                    alert(err.message);
                                                });
                                            }else{
                                                
                                                alert('Invalid Attribute Data, Check Again Your Input');
                                            }
                                        }
                                    }, "Add Attribute")
                                ])
                            ])
                        ])
                    ])
                ])
            ]),
            mithril("section", {class:"section"}, [
                mithril(Footer)
            ])
        ]);
    }
}